module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result"
  }, [_c('Title', [_vm._v("Результат")]), (!_vm.isChecked) ? _c('div', {
    staticClass: "result__checked"
  }, [_vm._v("На проверке")]) : [(_vm.isOffset) ? _c('div', {
    staticClass: "result__res"
  }, [_vm._v(_vm._s(_vm.offset))]) : _c('div', {
    staticClass: "result__res"
  }, [_vm._v("Оценка: "), _c('strong', [_vm._v(_vm._s(_vm.result.rate))])]), (_vm.result.rate_comment) ? _c('div', {
    staticClass: "result__description"
  }, [_vm._v(_vm._s(_vm.result.rate_comment))]) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2819d93e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/components/block/components/result/Result.vue
// module id = 841970c0c304635b3561
// module chunks = 89